import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.viewHandlingList.details.infoSection.title',
    defaultMessage: 'Information',
    description: 'label of the handling lists information section',
  },
  properties: {
    location: {
      id: 'properties.location',
      defaultMessage: 'Location',
      description: 'label of the location property of the handling list',
    },
    startedAt: {
      id: 'properties.startedAt',
      defaultMessage: 'Started at',
      description: 'label of the started at property of the handling list',
    },
    finishedAt: {
      id: 'properties.finishedAt',
      defaultMessage: 'Finished at',
      description: 'label of the finished at property of the handling list',
    },
    createdAt: {
      id: 'properties.createdAt',
      defaultMessage: 'Created at',
      description: 'label of the created at property of the handling list',
    },
    updatedAt: {
      id: 'properties.updatedAt',
      defaultMessage: 'Updated at',
      description: 'label of the updated at property of the handling list',
    },
    dueAt: {
      id: 'dataGrid.columns.handling.dueAt',
      defaultMessage: 'Due at',
      description: 'label of the due at property of the handling list',
    },
  },
};

export default defineMessages(translations);
